import { useEffect, useState } from "react";
import { Card, CardBody, Col, Row, Spinner, Table } from "reactstrap";
import { getBatchCompletedApi, getBatchNotStartedApi, getBatchOngoingApi, getBatchTotalApi, getBatchUpcomingApi, getCoordinatorDashboardApi, getFeesListApi, getMyFollowUpsApi } from "../../api/apiUrlConst";
import { toast } from "react-toastify";
import ShowChartIcon from '@mui/icons-material/ShowChart';

interface DashboardStats {
  totalEnquiries: number;
  joined: number;
  followUpsToday: number;
  pendingPayments: number;
  totalCollected: number;
}

const CoordinatorDashboard = () => {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [todayFollowUps, setTodayFollowUps] = useState<any[]>([]);
  const [todayPayments, setTodayPayments] = useState<any[]>([]);

  const [batchStats, setBatchStats] = useState({
  total: 0,
  notStarted: 0,
  upcoming: 0,
  ongoing: 0,
  completed: 0
});


const loadBatchStats = async () => {
  try {
    const [
      total,
      notStarted,
      upcoming,
      ongoing,
      completed
    ] = await Promise.all([
      getBatchTotalApi(),
      getBatchNotStartedApi(),
      getBatchUpcomingApi(),
      getBatchOngoingApi(),
      getBatchCompletedApi()
    ]);

    setBatchStats({
      total,
      notStarted,
      upcoming,
      ongoing,
      completed
    });
  } catch {
    toast.error("Failed to load batch stats");
  }
};

 const loadTodayData = async () => {
  try {

    const followups = await getMyFollowUpsApi();

    const today = new Date().toISOString().split("T")[0];


    // ✅ Payment Due Today
    const payments = await getFeesListApi();

    const todayP = payments.filter((p: any) =>
      p.nextDueDate &&
      p.pendingAmount > 0 &&
      p.nextDueDate.split("T")[0] === today
    );

    setTodayPayments(todayP);

  } catch {
    toast.error("Failed to load today data");
  }
};


useEffect(() => {
  loadDashboard();
  loadTodayData();
  loadBatchStats();
}, []);

  const loadDashboard = async () => {
    try {
      const data = await getCoordinatorDashboardApi();
      setStats(data);
    } catch (error: any) {
      toast.error(error.response?.data || "Failed to load dashboard");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDashboard();
  }, []);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner color="primary" />
      </div>
    );
  }





  return (
    <div
      
      style={{ background: "#f4f6fb", minHeight: "100vh" }}
    >
      {/* ===== DASHBOARD HEADER ===== */}
      <div
        className="p-4 mb-4"
        style={{
          background: "linear-gradient(90deg, #374151, #093d92)",
          borderRadius: "16px",
          color: "#fff",
        }}
      >
        <h3 className="fw-bold mb-1">Coordinator Dashboard</h3>
        <small>Overview of your performance and revenue</small>
      </div>

      {/* ===== STATS ROW ===== */}
      <Row className="g-4">
        {/* Total Enquiries */}
        <Col md={2}>
          <Card className="border-0 shadow-sm rounded-4 h-100 hover-card">
            <CardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">
                  Total Enquiries
                </div>
                <h3 className="fw-bold text-primary mb-0">
                  {stats?.totalEnquiries ?? 0}
                </h3>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  background: "#e7f5ff",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                }}
              >
                📋
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Joined */}
        <Col md={2}>
          <Card className="border-0 shadow-sm rounded-4 h-100">
            <CardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">Joined</div>
                <h3 className="fw-bold text-success mb-0">
                  {stats?.joined ?? 0}
                </h3>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  background: "#ebfbee",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                }}
              >
                🎓
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Follow Ups Today */}
        <Col md={2}>
          <Card className="border-0 shadow-sm rounded-4 h-100">
            <CardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">
                  Follow Ups 
                </div>
                <h3 className="fw-bold text-warning mb-0">
                  {stats?.followUpsToday ?? 0}
                </h3>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  background: "#fff3bf",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                }}
              >
                🔔
              </div>
            </CardBody>
          </Card>
        </Col>

        {/* Pending Payments */}
        <Col md={2}>
          <Card className="border-0 shadow-sm rounded-4 h-100">
            <CardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">
                  Pending Payments
                </div>
                <h3 className="fw-bold text-danger mb-0">
                  {stats?.pendingPayments ?? 0}
                </h3>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  background: "#ffe3e3",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                }}
              >
                💰
              </div>
            </CardBody>
          </Card>
        </Col>

         <Col md={2}>
          <Card className="border-0 shadow-sm rounded-4 h-100">
            <CardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">
                  Total Collected
                </div>
                <h3 className="fw-bold text-danger mb-0">
                  ₹ {stats?.totalCollected?.toLocaleString() ?? 0}
                </h3>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  background: "#ffe3e3",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                }}
              >
                <ShowChartIcon />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* ===== FINANCIAL CARD ===== */}
      <Row className="mt-4">
       

     

      <Col md={2}>
          <Card className="border-0 shadow-sm rounded-4 h-100">
            <CardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">
                  Total Batches
                </div>
                <h3 className="fw-bold text-primary mb-0">
                {batchStats.total}
                </h3>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  background: "#c0d7f0",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                }}
              >
                📜
              </div>
            </CardBody>
          </Card>
        </Col>
      <Col md={2}>
          <Card className="border-0 shadow-sm rounded-4 h-100">
            <CardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">
                  Not Started
                </div>
                <h3 className="fw-bold text-secondary mb-0">
                {batchStats.notStarted}
                </h3>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  background: "#e4e3dc",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                }}
              >
               ⏳
              </div>
            </CardBody>
          </Card>
        </Col>
      <Col md={2}>
          <Card className="border-0 shadow-sm rounded-4 h-100">
            <CardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">
                 Upcoming
                </div>
                <h3 className="fw-bold text-warning mb-0">
                {batchStats.upcoming}
                </h3>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  background: "#faf098",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                }}
              >
                📅
              </div>
            </CardBody>
          </Card>
        </Col>
      <Col md={2}>
          <Card className="border-0 shadow-sm rounded-4 h-100">
            <CardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">
                  Ongoing
                </div>
                <h3 className="fw-bold text-success mb-0">
                {batchStats.ongoing}
                </h3>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  background: "#d2f1c0",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                }}
              >
                🕰️
              </div>
            </CardBody>
          </Card>
        </Col>
      <Col md={2}>
          <Card className="border-0 shadow-sm rounded-4 h-100">
            <CardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-muted small">
                  Completed
                </div>
                <h3 className="fw-bold text-dark mb-0">
                {batchStats.completed}
                </h3>
              </div>

              <div
                style={{
                  width: "50px",
                  height: "50px",
                  background: "#f1bdbd",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                }}
              >
                ✔️
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">

        <Col md={12}>
          <Card className="shadow-sm border-0 rounded-4">
            <CardBody>

              <h5 className="fw-bold mb-3">Today's Payments</h5>

              <Table hover responsive>

                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Course</th>
                     <th>Pending Amount</th>
                      <th>Mobile</th>
                   
                  
                  </tr>
                </thead>

                <tbody>

                  {todayPayments.length === 0 && (
                    <tr>
                      <td colSpan={5} className="text-center text-muted">
                        No Payments Today
                      </td>
                    </tr>
                  )}

                  {todayPayments.map((p) => (
                    <tr key={p.id}>
                      <td>{p.name}</td>
                      <td>{p.course}</td>
                      <td className="fw-bold text-success">
                        ₹ {p.pendingAmount}
                      </td>
                      <td>{p.phoneNo}</td>
                      <td>
                       
                      </td>
                    </tr>
                  ))}

                </tbody>

              </Table>

            </CardBody>
          </Card>
        </Col>

      </Row>


    </div>
  );
};

export default CoordinatorDashboard;